// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { MaintenanceModel } from "@keller/App/Services/MaintenanceService";
import { Draft } from "immer";

export type xMaintenanceStateType = Readonly<{
    isLoading?: boolean;
    failedMessage?: string;
    data?: MaintenanceModel;
}>;

export const initialMaintenanceState: xMaintenanceStateType = {
    isLoading: false,
    data: undefined,
    failedMessage: "",
};

const reducer = {
    "xMaintenance/BeginLoadMaintenance": (draft: Draft<xMaintenanceStateType>, action: {}) => {
        draft.isLoading = true;
        draft.failedMessage = "";
    },
    "xMaintenance/CompleteLoadMaintenance": (
        draft: Draft<xMaintenanceStateType>,
        action: { data: MaintenanceModel },
    ) => {
        draft.isLoading = false;
        draft.failedMessage = "";

        draft.data = {
            ...action.data,
        };
    },
    "xMaintenance/FailedLoadMaintenance": (draft: Draft<xMaintenanceStateType>, action: { failedMessage: string }) => {
        draft.isLoading = false;
        draft.failedMessage = action.failedMessage;
    },
};

const xMaintenance = createTypedReducerWithImmer(initialMaintenanceState, reducer);

(reducers as any).xMaintenance = xMaintenance;

export type xMaintenanceState = {
    xMaintenance: xMaintenanceStateType;
} & ApplicationState;

type xMaintenanceReducers = {
    [key: string]: typeof xMaintenance;
};

export type xMaintenanceActions = Parameters<xMaintenanceReducers[keyof xMaintenanceReducers]>[1] | AnyAction;
